import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shared--autosubmit"
// Automatically submits the form it is attached to on connect.
export default class extends Controller {
  connect() {
    this.element.requestSubmit();
  }
}
